<template>
    <v-container fluid fill-height>

        <v-layout class="profile">

            <v-flex xs12>
                    <v-toolbar flat color="white">
                        <v-toolbar-title>Информация о Заказчике </v-toolbar-title>
                        <v-divider
                                class="mx-2"
                                inset
                                vertical
                        ></v-divider>
                        <v-spacer></v-spacer>
                    </v-toolbar>

                    <v-container fluid grid-list-md customer-info>
                         <v-layout wrap>
                        <v-flex xs12 sm6 md6>
                            <p class="filed-title">ИНН</p>
                            <div class="filed-block">{{customerInfo.inn}}</div>
                        </v-flex>

                        <v-flex xs12 sm6 md6>
                            <p class="filed-title">Адрес элетронной почты</p>
                            <div class="filed-block">{{customerInfo.email}}</div>
                        </v-flex>

                        <v-flex xs12 sm6 md6>
                            <p class="filed-title">Наименование</p>
                            <div class="filed-block-area">{{customerInfo.name}}</div>
                        </v-flex>
                        <v-flex xs12 sm6 md6>
                            <p class="filed-title">Телефон</p>
                            <div class="filed-block-area">{{customerInfo.phone}}</div>
                        </v-flex>

                        <v-flex xs12 sm6 md6>
                            <p class="filed-title">Адрес (место нахождения)</p>
                            <div class="filed-block-area">{{customerInfo.address}}</div>
                        </v-flex>

                        <v-flex xs12 sm6 md6>
                            <p class="filed-title">Почтовый адрес</p>
                            <div class="filed-block-area">{{customerInfo.mailAddress}}</div>
                        </v-flex>


                    </v-layout>
                    </v-container>

                    <v-divider style="margin: 30px 0;"></v-divider>

                    <v-toolbar flat color="white">
                        <v-toolbar-title>Контактные лица</v-toolbar-title>
                        <v-divider
                                class="mx-2"
                                inset
                                vertical
                        ></v-divider>
                    </v-toolbar>

                    <v-data-table
                            :headers="headers4"
                            :role="role"
                            :items="contactPersons"
                            :light=true
                            no-data-text=""
                            :rows-per-page-items='[ 5, 15, 30, { "text": "все", "value": -1 } ]'
                            rows-per-page-text="Строк на странице"
                            class="elevation-1"
                    >
                        <template slot="items" slot-scope="props">
                            <td>{{ props.item.fio }}</td>
                            <td>{{ '+7 ' + phoneNumberFormat(props.item.phone) }}</td>
                            <td>{{ props.item.email }}</td>
                            <!--<td v-if="role == 'ROLE_CUSTOMER_ADMIN'" class="justify-center layout px-0">-->

                                <!--<v-tooltip v-if="role != 'ROLE_EXPERT'" top>-->
                                    <!--<v-btn slot="activator" color="primary" flat icon @click="editItem(props.item)">-->
                                        <!--<v-icon small>edit</v-icon>-->
                                    <!--</v-btn>-->
                                    <!--<span>Edit Customer</span>-->
                                <!--</v-tooltip>-->
                                <!--<v-tooltip v-if="role != 'ROLE_EXPERT'" top>-->
                                    <!--<v-btn slot="activator" color="red" flat icon @click="deleteItem(props.item)">-->
                                        <!--<v-icon small>delete</v-icon>-->
                                    <!--</v-btn>-->
                                    <!--<span>Delete Customer</span>-->
                                <!--</v-tooltip>-->

                            <!--</td>-->
                        </template>
                    </v-data-table>

                    <v-divider style="margin: 30px 0;"></v-divider>

                    <v-toolbar flat color="white">
                        <v-toolbar-title>Сотрудники заказчика</v-toolbar-title>
                        <v-divider
                                class="mx-2"
                                inset
                                vertical
                        ></v-divider>
                        <v-spacer></v-spacer>
                        <v-btn v-if="this.role == 'ROLE_ADMIN' || this.role == 'ROLE_CUSTOMER_ADMIN'" color="info" dark class="mb-2" @click="openDialog">Добавить сотрудника</v-btn>
                        <v-dialog v-if="this.role == 'ROLE_ADMIN' || this.role == 'ROLE_CUSTOMER_ADMIN'" v-model="dialog" max-width="800px">
                            <v-card>
                                <v-card-title>
                                    <span class="headline">{{ formTitle }}</span>
                                </v-card-title>
                                <v-alert
                                        :value="successAlert"
                                        dismissible
                                        type="success"
                                >
                                    {{successText}}
                                </v-alert>
                                <v-form
                                        ref="form"
                                        v-model="valid"
                                        lazy-validation
                                >
                                    <v-card-text>
                                        <v-container grid-list-md>
                                            <v-layout wrap>
                                                <v-flex xs12 sm6 md6 field-block>
                                                    <div v-if="editedItem.username && editedItem.username.length >= 76 && editedItem.username.length < 100" class='max-length-block'>Осталось {{100 - editedItem.username.length}} символов</div>
                                                    <v-text-field v-model="editedItem.username" :rules="requiredRules" :error-messages="inputErrors.username" maxlength="100" required>
                                                        <template slot="label">
                                                            Логин сотрудника <span class='error-file'>*</span>
                                                        </template>
                                                    </v-text-field>
                                                </v-flex>
                                                <v-flex xs12 sm6 md6 field-block>
                                                    <div v-if="editedItem.fullname && editedItem.fullname.length >= 76 && editedItem.fullname.length < 100" class='max-length-block'>Осталось {{100 - editedItem.fullname.length}} символов</div>

                                                    <v-textarea v-model="editedItem.fullname" rows="1" :rules="requiredRules" :error-messages="inputErrors.fullname" maxlength="100" required>
                                                        <template slot="label">
                                                            ФИО <span class='error-file'>*</span>
                                                        </template>
                                                    </v-textarea>
                                                </v-flex>
                                                <v-flex xs12 sm6 md6 field-block>
                                                    <div v-if="editedItem.email && editedItem.email.length >= 76 && editedItem.email.length < 100" class='max-length-block'>Осталось {{100 - editedItem.email.length}} символов</div>

                                                    <v-text-field v-model="editedItem.email" :rules="emailRules" :error-messages="inputErrors.email" maxlength="100" required>
                                                        <template slot="label">
                                                            Адрес элетронной почты <span class='error-file'>*</span>
                                                        </template>
                                                    </v-text-field>
                                                </v-flex>
                                                <v-flex xs12 sm6 md6 field-block>
                                                    <div v-if="editedItem.password && editedItem.password.length >= 76 && editedItem.password.length < 100" class='max-length-block'>Осталось {{100 - editedItem.password.length}} символов</div>

                                                    <v-text-field v-model="editedItem.password" :rules="passwordRules" :error-messages="inputErrors.password" maxlength="100" required>
                                                        <template slot="label">
                                                            Пароль <span v-if="editedIndex == -1" class='error-file'>*</span>
                                                        </template>
                                                    </v-text-field>
                                                </v-flex>
                                                <v-flex xs12 sm6 md6>
                                                    <v-select
                                                            :items="roles"
                                                            item-text="name"
                                                            item-value="val"
                                                            label="Роль"
                                                            no-data-text="Нет доступных для выбора"
                                                            v-model="editedItem.role"
                                                            disabled
                                                    ></v-select>
                                                </v-flex>

                                            </v-layout>
                                        </v-container>
                                    </v-card-text>

                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn color="blue darken-1" flat @click="close">Отменить</v-btn>
                                        <v-btn color="success" flat @click="save">Сохранить</v-btn>
                                    </v-card-actions>
                                </v-form>
                            </v-card>
                        </v-dialog>

                    </v-toolbar>

                    <v-alert
                            :value="deleteTextAlert"
                            type="success"
                    >
                        {{deleteText}}
                    </v-alert>

                    <v-data-table
                            :headers="role == 'ROLE_ADMIN' ? headers2 : headers3"
                            :role="role"
                            :items="users"
                            :light=true
                            no-data-text=""
                            rows-per-page-text="Строк на странице"
                            :rows-per-page-items='[ 5, 15, 30, { "text": "все", "value": -1 } ]'
                            class="elevation-1"


                    >
                        <template slot="items" slot-scope="props">

                            <td>{{ props.item.username }}</td>
                            <td>{{ props.item.fullname }}</td>
                            <td>{{ props.item.email }}</td>
                            <td>{{ showRole(props.item.role) }}</td>
                            <td v-if="role == 'ROLE_ADMIN'" class="action-buttons justify-center">

                                <v-btn v-if="props.item.role == 'ROLE_CUSTOMER_ADMIN'" color="primary" flat icon @click="editItem(props.item)">
                                    <v-icon small>fa-pencil</v-icon>
                                </v-btn>
                                <v-btn v-if="props.item.role == 'ROLE_CUSTOMER_ADMIN'" color="red" flat icon @click="deleteItem(props.item)">
                                    <v-icon small>fa-trash</v-icon>
                                </v-btn>
                            </td>
                        </template>
                    </v-data-table>

                    <v-divider style="margin: 30px 0;"></v-divider>

                    <v-toolbar flat color="white" style="margin-top: 50px">
                        <v-toolbar-title>Реквизиты счета</v-toolbar-title>
                        <v-divider
                                class="mx-2"
                                inset
                                vertical
                        ></v-divider>
                        <v-spacer></v-spacer>
                    </v-toolbar>

                    <v-data-table
                        :headers="headers"
                        :role="role"
                        :items="accountDetails"
                        :light=true
                        no-data-text=""
                        rows-per-page-text="Строк на странице"
                        class="elevation-1"
                >
                    <template slot="items" slot-scope="props">
                        <td>{{ props.item.receiver }}</td>
                        <td>{{ props.item.personalAccount }}</td>
                        <td>{{ props.item.inn }}</td>
                        <td>{{ props.item.kpp }}</td>
                        <td>{{ props.item.account }}</td>
                        <td>{{ props.item.bic }}</td>
                        <td>{{ props.item.correspondentAccount }} </td>
                        <td>{{ props.item.bankName }}</td>
                        <td>{{ props.item.goalCode }}</td>
                    </template>
                </v-data-table>
            </v-flex>

        </v-layout>
    </v-container>
</template>

<script>
    import axios from 'axios'
    export default {
        data (){
            return {
                backUrl: null,
                valid: true,
                customerID: null,
                role: null,
                customerInfo: {},
                contactPersons: [],
                token: '',
                dialog: false,
                headers: [
                    { text: 'Получатель',value: 'receiver'},
                    { text: 'Лицевой счет',value: 'personalAccount'},
                    { text: 'ИНН',value: 'inn'},
                    { text: 'КПП', value: 'kpp' },
                    { text: 'Расчетный счет', value: 'account' },
                    { text: 'БИК', value: 'bic' },
                    { text: 'Корреспондентский счет', value: 'correspondentAccount' },
                    { text: 'Наименование банка', value: 'bankName' },
                    { text: 'Код цели', value: 'goalCode' },
                ],
                headers2: [
                    { text: 'Логин сотрудника',value: 'username'},
                    { text: 'ФИО', value: 'fullname' },
                    { text: 'Адрес элетронной почты', value: 'email' },
                    { text: 'Роль', value: 'role' },
                    { text: 'Действия',align: 'center',class: 'agent-actions', sortable: false }
                ],
                headers3: [
                    { text: 'Логин сотрудника',value: 'username'},
                    { text: 'ФИО', value: 'fullname' },
                    { text: 'Адрес элетронной почты', value: 'email' },
                    { text: 'Роль', value: 'role' },
                ],
                headers4: [
                    { text: 'ФИО',value: 'fio'},
                    { text: 'Телефон',value: 'phone'},
                    { text: 'Адрес элетронной почты',value: 'email'},
                ],
                roles: [
                    {
                        name: "Администратор",
                        val: "ROLE_CUSTOMER_ADMIN"
                    }
                ],

                requiredRules: [
                    v => !!v || 'Значение должно быть заполнено',
                ],
                passwordRules: [
                    v => !!v || 'Значение должно быть заполнено',
                ],
                emailRules: [
                    (v) => !!v || 'Значение должно быть заполнено',
                     v => {
                        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                        return pattern.test(v) || 'Адрес элетронной почты должен быть действительным'
                     },
                ],
                innRules: [
                    v => !!v || 'Значение должно быть заполнено',
                    v => (v && v.length == 10) || 'ИНН должен содержать 10 цифр (другие символы недопустимы)',
                ],

                accountDetails: [],
                editedIndex: -1,
                inputErrors:[],
                users: [],
                deleteText:'',
                deleteTextAlert: false,
                successAlert:false,
                successText:'',

                editedItem: {
                    id: '',
                    uuid: '',
                    username: '',
                    fullname: '',
                    email: '',
                    status: '',
                    customerId: '',
                    password: '',
                    role :  'ROLE_CUSTOMER_ADMIN'
                },

                defaultItem: {
                    username: '',
                    fullname: '',
                    password: '',
                    status: '',
                    email: '',
                    customerId: '',
                    role: '',
                },
        }
        },

        created () {
            this.customerID = this.$route.params.id
            this.token = localStorage.getItem('token');
            this.role = localStorage.getItem('role');
            this.backUrl = localStorage.getItem('url');
            this.getCustomers();
            this.getUsers();
            this.getAccountDetails();
            this.getContactPersons();

        },

        computed: {
            formTitle () {
                return this.editedIndex === -1 ? 'Новый сотрудник' : 'Редактировать сотрудника'
            },
        },

        watch: {
            dialog (val) {
                val || this.close()
            },
        },

        methods:{
            getCustomers(){
                axios({
                    method: 'get',
                    url: this.backUrl + '/api/customers/' + this.customerID,
                    withCredentials: true,
                    headers:{
                        'Authorization': 'Basic ' + this.token
                    },
                }).then(response => {
                    if(response.data){
                        this.customerInfo = response.data
                        this.customerInfo.phone = '+7 ' + this.phoneNumberFormat(this.customerInfo.phone)
                    }
                })
            },

            getContactPersons(){
                this.deleteText = ''
                this.deleteTextAlert = false

                axios({
                    method: 'get',
                    url: this.backUrl + '/api/persons',
                    withCredentials: true,
                    headers:{
                        'Authorization': 'Basic ' + this.token
                    },
                }).then(response => {
                    for (let i = 0; i < response.data.data.length; i++){
                        if(this.customerID == response.data.data[i].customerId){
                            this.contactPersons.push(response.data.data[i])
                        }
                    }
                })
            },

            phoneNumberFormat(item){
                if(item) {
                    let USNumber = item.match(/(\d{3})(\d{3})(\d{2})(\d{2})/);
                    return "(" + USNumber[1] + ") " + USNumber[2] + "-" + USNumber[3] + "-" + USNumber[4];
                }
            },

            getAccountDetails(){
                axios({
                    method: 'get',
                    url: this.backUrl + '/api/accountDetails',
                    withCredentials: true,
                    headers:{
                        'Authorization': 'Basic ' + this.token
                    },
                }).then(response => {

                    for(let i=0; i < response.data.data.length; i++){
                            if(this.customerID == response.data.data[i].customerId){
                                this.accountDetails.push({
                                    receiver: response.data.data[i].receiver,
                                    personalAccount: response.data.data[i].personalAccount,
                                    inn: response.data.data[i].inn,
                                    kpp: response.data.data[i].kpp,
                                    account: response.data.data[i].account,
                                    bic: response.data.data[i].bic,
                                    correspondentAccount: response.data.data[i].correspondentAccount,
                                    bankName: response.data.data[i].bankName,
                                    goalCode: response.data.data[i].goalCode,
                                })
                            }
                    }

                })
            },

            showRole(role){

                   if (role == "ROLE_CUSTOMER_ADMIN") {
                        return "Администратор"
                    } else if (role == 'ROLE_CUSTOMER_WORKER'){
                        return "Сотрудник"
                    }

            },

            getUsers(){
                this.deleteText = ''
                this.deleteTextAlert = false

                axios({
                    method: 'get',
                    url: this.backUrl + '/api/users',
                    withCredentials: true,
                    headers:{
                        'Authorization': 'Basic ' + this.token
                    },
                }).then(response => {
                   let users = []
                    for(let i = 0;i < response.data.data.length; i++){
                        if(response.data.data[i].customerId == this.customerID){
                            users.push(response.data.data[i])
                        }
                    }
                    this.users = users
                })
            },

            openDialog(){
                this.inputErrors = ''
                this.passwordRules = [
                    v => !!v || 'Значение должно быть заполнено',
                ],
                this.$refs.form.resetValidation()
                this.dialog = true
            },

            editItem (item) {
                this.inputErrors = ''
                this.passwordRules = []
                this.editedIndex = this.users.indexOf(item)
                this.editedItem = Object.assign({}, item)
                this.dialog = true
            },

            deleteItem (item) {
                this.editedItem = Object.assign({}, item)
                const index = this.users.indexOf(item)

                if(confirm('Вы уверены, что хотите удалить этого сотрудника ?')) {
                    axios({
                        method: 'delete',
                        url: this.backUrl + '/api/users',
                        withCredentials: true,
                        headers:{
                            'Authorization': 'Basic ' + this.token
                        },
                        data: {
                            id: this.editedItem.id,
                            uuid: this.editedItem.uuid,
                        },
                    }).then(() => {
                        this.users.splice(index, 1)
                        this.deleteText = 'Успешно удален'
                        this.deleteTextAlert = true
                        setTimeout(() => {
                            this.deleteTextAlert = false
                        }, 3000)
                    }).catch(error => {
                        if(error.response.data.code == 401){
                            this.$router.push('/login');
                        }
                    });
                }

            },

            close () {
                this.dialog = false
                setTimeout(() => {
                    this.editedItem = Object.assign({}, this.defaultItem)
                    this.editedIndex = -1
                    this.inputErrors = ''
                    this.successAlert = false
                    this.successText = ''
                    this.deleteText = ''
                    this.deleteTextAlert = false
                }, 300)

            },

            save () {
                this.inputErrors = ''
                if (this.$refs.form.validate()) {
                    if (this.editedIndex == -1) {
                        axios({
                            method: 'post',
                            url: this.backUrl + '/api/users',
                            withCredentials: true,
                            headers:{
                                'Authorization': 'Basic ' + this.token
                            },
                            data: {
                                fullname: this.editedItem.fullname,
                                status: 'ACTIVE',
                                customerId: this.customerInfo.id,
                                email: this.editedItem.email,
                                role: 'ROLE_CUSTOMER_ADMIN',
                                username: this.editedItem.username,
                                password: this.editedItem.password,
                            },
                        }).then(() => {
                            this.inputErrors = ''
                            this.users.push(this.editedItem)

                            this.successText = 'Успешно добавлен'
                            this.successAlert = true
                            this.getUsers();
                            setTimeout(() => {
                                this.close()
                            }, 1500)
                        }).catch(error => {
                            if(error.response.data.code == 401){
                                this.$router.push('/login');
                            }
                            let errors = error.response.data.rows;
                            this.inputErrors = errors

                        });

                    } else {
                        axios({
                            method: 'put',
                            url: this.backUrl + '/api/users',
                            withCredentials: true,
                            headers:{
                                'Authorization': 'Basic ' + this.token
                            },
                            data: {
                                id: this.editedItem.id,
                                uuid: this.editedItem.uuid,
                                customerId: this.customerInfo.id,
                                fullname: this.editedItem.fullname,
                                email: this.editedItem.email,
                                role: 'ROLE_CUSTOMER_ADMIN',
                                username: this.editedItem.username,
                                password: this.editedItem.password,
                            },
                        }).then(() => {
                            this.inputErrors = ''
                            Object.assign(this.users[this.editedIndex], this.editedItem)
                            this.successText = 'Успешно изменен'
                            this.successAlert = true
                            this.getUsers();
                            setTimeout(() => {
                                this.close()
                            }, 1500)
                        }).catch(error => {
                            if(error.response.data.code == 401){
                                this.$router.push('/login');
                            }
                            let errors = error.response.data.rows;
                            this.inputErrors = errors

                        });
                    }
                }

            },

        }
    }
</script>

<style>

</style>